<template>
  <div>
    <b-container>
      <div v-if="isGlobalApp" class="d-flex justify-content-center mt-2 mb-2">
        <b-img width="150" height="130" :src="require('@base/assets/images/flealover-sitelogo.png')" />
      </div>
      <div v-else class="d-flex justify-content-center">
        <b-img :src="require('@base/assets/images/sitelogo.png')" />
      </div>
      <b-row class="justify-content-center"><h2 class="text-center">{{ $t('pages.login.admin.welcome') }}</h2></b-row>
      <b-row class="justify-content-center">
        <b-form @submit.prevent="authAdminUser" class="w-50">
          <b-form-group
            id="username-group"
            :label="$t('auth.login')"
            label-for="username"
            :invalid-feedback="invalidCredentials"
            :state="stateUsername"
          >
            <b-form-input
              id="username"
              v-model="username"
              type="text"
              :state="stateUsernameInput"
              :placeholder="$t('auth.field.username')"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="password-group"
            :label="$t('auth.password')"
            label-for="password"
            :invalid-feedback="invalidPassword"
            :state="statePassword"
          >
            <b-form-input
              id="password"
              v-model="password"
              type="password"
              @blur="invalidCredentials = null"
              :state="statePasswordInput"
              :placeholder="$t('auth.placeholder_password')"
            ></b-form-input>
          </b-form-group>
          <vue-recaptcha
            v-if="useRecaptcha"
            ref="recaptcha"
            @expired="onCaptchaExpired"
            @verify="onCaptchaVerified"
            @error="onRecaptchaError"
            :sitekey="recaptchaSiteKey"
            size="invisible" />
          <div class="form-actions">
            <b-button
              type="submit"
              :disabled="loading"
              variant="primary">
              {{ $t('auth.login_button') }}
            </b-button>
          </div>
        </b-form>
      </b-row>
      <b-row class="justify-content-center mt-2">
        <p class="text-center">
          {{ $t('auth.forgot_password') }}
          <router-link :to="{ name: 'admin-reset-password' }">
            {{ $t('auth.reset_password') }}
          </router-link>
        </p>
      </b-row>
    </b-container>

  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha'
  import { RECAPTCHA_SITE_KEY, ADMIN_SECTION_PATH, USE_RECAPTCHA, IS_GLOBAL_APP } from '@base/configs'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'AdminLogin',

    components: { VueRecaptcha },

    data () {
      return {
        username: null,
        password: null,
        invalidCredentials: null,
        useRecaptcha: USE_RECAPTCHA,
        recaptchaToken: null,
        recaptchaSiteKey: RECAPTCHA_SITE_KEY,
        recaptchaError: false,
        loading: false,
        isGlobalApp: IS_GLOBAL_APP,
      }
    },

    watch: {
      username () {
        this.invalidCredentials = null
      },
      password () {
        this.invalidCredentials = null
      },
    },

    computed: {
      payloads () {
        return {
          username: this.username,
          password: this.password,
          grecaptcha_token: this.useRecaptcha ? this.recaptchaToken: undefined,
        }
      },
      stateUsernameInput () {
        return this.invalidCredentials !== null ? false : null
      },
      stateUsername () {
        return this.invalidCredentials === null
      },
      statePasswordInput () {
        return (this.$v.password.$error || this.invalidCredentials !== null) ? false : null
      },
      statePassword () {
        return !this.$v.password.$error || this.invalidCredentials !== null
      },
      invalidPassword () {
        if (this.$v.password.$error) {
          if (!this.$v.password.required)
            return this.$t('validation.required', { field: this.$t('auth.field.password') })
        }
        return null
      },
    },

    validations: {
      username: {
        required,
      },
      password: {
        required
      },
    },

    methods: {
      onRecaptchaError () {
        this.recaptchaError = true
      },

      onCaptchaExpired () {
        if (this.useRecaptcha)
          this.$refs.recaptcha.reset()
      },

      authAdminUser () {
        this.$v.$touch()
        if (this.useRecaptcha) {
          if (this.recaptchaError) {
            this.$notify({
              group: 'app',
              type: 'error',
              title: this.$t('notifications.title.error'),
              text: this.$t('error.recaptcha')
            })
            return
          }
        }
        if (!this.$v.$invalid) {
          if (this.useRecaptcha)
            this.$refs.recaptcha.execute()
          else
            this.onCaptchaVerified()
        }
      },

      onCaptchaVerified (recaptchaToken) {
        this.$v.$reset()
        this.invalidCredentials = null
        if (this.useRecaptcha) {
          this.recaptchaToken = recaptchaToken
          this.$refs.recaptcha.reset()
        }
        this.loading = true
        this.loader = this.$loading.show(this.$_loaderOptions)
        this.$store.dispatch(this.$_actionTypes.LOGIN_USER, this.payloads)
          .then((response) => {
            if (response.isAdmin) {
              window.location.replace(ADMIN_SECTION_PATH)
            } else {
              this.$notify({
                group: 'app',
                type: 'warn',
                title: this.$t('notifications.title.warning'),
                text: this.$t('error.permission_denied')
              })
            }
          })
          .catch((error) => {
            this.invalidCredentials = error.data.error
            this.$notify({
              group: 'app',
              type: 'error',
              title: this.$t('notifications.title.error'),
              text: error.data.error
            })
          })
          .finally(() => {
            this.loading = false
            this.loader.hide()
          })
      }
    }
  }
</script>

<style>

</style>
